// extracted by mini-css-extract-plugin
module.exports = {"button":"_99551c8aa8--button--DsA7r"};